import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ViewService } from "../services/view.service"
import { ViewSummaryItem, View } from '../objects/ViewObject';
import { ConfirmationService } from '../services/confirmation.service';
import { ConversationService } from '../services/conversation.service';
import { ContextMenuService, ContextMenuComponent } from 'node_modules/ngx-contextmenu';

@Component({
  selector: 'app-treeview',
  templateUrl: './treeview.component.html',
  styleUrls: ['./treeview.component.css']
})
export class TreeviewComponent implements OnInit {

  @ViewChild(ContextMenuComponent) public basicMenu: ContextMenuComponent;
  
  @Input() viewList:ViewSummaryItem[];
  @Input() componentId:string;
  @Input() currentView: string;
  @Input() draggable:boolean;
  @Output() viewSelected = new EventEmitter<any>();
  
  private currentItem: string;
  private childView: string;
  private selectedView:string;
  private isBusy :boolean = false;
  constructor(private viewService:ViewService,private contextMenuService:ContextMenuService, private confirmationService: ConfirmationService, private conversationService : ConversationService, private view: View) { }

  ngOnInit() {
  }

  getViewChild(viewId:string){
    this.viewService.getViewChildrenList(this.componentId, viewId).subscribe(result=> {
      this.childView = JSON.parse(result);
      this.viewList.find(x=> x.ViewID == viewId).ChildList = JSON.parse(result);
    })
  }

  selectView(viewId:string){
    this.viewSelected.emit(0);
    this.viewService.getViewDetail(this.componentId, viewId).subscribe(result=> {
      this.selectedView = viewId;
      this.viewSelected.emit(result);
    },error => {
      this.viewSelected.emit(1);
    })
  }

  viewSelectedChanged(result:any){
    this.viewSelected.emit(result);
  }

  pullPopup(view: ViewSummaryItem) {
    //$event.stopPropagation();
    this.confirmationService.confirm(
      "Add Quick Phrase for " + view.ViewName,
      "",
      ["CANCEL", "OK"], true, "Add Quick Phrase...", true)
      .subscribe((respond) => {
        if (respond.answer == "OK"){
          this.isBusy = true;
          this.conversationService.saveUtteranceForPersonalizedView(respond.inputText, view.ViewID).subscribe(result => {
            console.log(result);
          })
          
        }
      });
  }

  public onContextMenu($event, item: ViewSummaryItem): void {
    this.currentItem = item.ViewID;
    if($event.button == 0){
      this.contextMenuService.show.next({
        contextMenu: this.basicMenu,
        event: $event,
        item: item,
      });
    }
    $event.preventDefault();
    $event.stopPropagation();
  }

  onCloseContextMenu() {
    this.currentItem = '';
  }

  dragging = null;
  handleDragStart(e) {
    //this.style.opacity = '0.4';
    this.dragging = e.target.closest('.list-item');
    if (e.target.classList.contains('list-item')){
      this.dragging = e.target;
    }
    // console.log(this.dragging);
    e.dataTransfer.setData('text/html', this.dragging);
  }

  handleDragOver(e) {
    if(this.draggable){
      e.preventDefault();
      // var bounding = e.target.parentNode.getBoundingClientRect();
      // var targetItemParent = e.target.closest('.list-container');
      var target = e.target.closest('.list-item');
      var bounding = target.getBoundingClientRect();
      var offset = bounding.y + (bounding.height / 2);
      if (e.clientY - offset > 0) {
        target.style['border-bottom'] = '1px solid #3BAFDA';
        target.style['border-top'] = '';
      } else {
        target.style['border-top'] = '1px solid #3BAFDA';
        target.style['border-bottom'] = '';
      }
      return false;
    }
  }

  handleDragLeave(e) {
    var target = e.target.closest('.list-item');
    target.style['border-bottom'] = '';
    target.style['border-top'] = '';
  }

  handleDrop(e) {
    e.preventDefault();
    // handle the elements inside the list
    var targetItem = e.target.closest('.list-container');
    var target = e.target.closest('.list-item');
    // console.log(target);
    // console.log(target.nextSibling);

    if (target.style['border-bottom'] !== '') {
      // console.log('bottom');
      // console.log(targetItem.insertBefore(this.dragging, target.nextSibling));
      target.style['border-bottom'] = '';
      targetItem.insertBefore(this.dragging, target.nextSibling);
    } else {
      // console.log('top');
      // console.log(targetItem.insertBefore(this.dragging, target));
      target.style['border-top'] = '';
      targetItem.insertBefore(this.dragging, target);
    }

    return false;
  }

  handleDragEnd(e) {
      // this/e.target is the source node.
      //this.style.opacity = '1';
      //[].forEach.call(cols, function (col) {
      //  col.classList.remove('over');
      //});
  }

  dropMe(event){
    if(event.source.children.length == 0){
      // remove label and input if parent dont have child anymore

      console.log('zero');
    }
    else{
      // this has to work
    }
  }
}
